
import Layout from "@/components/layout/Layout";
import { useEffect, useState } from "react";
import { ClienteService, GeradorService } from "@/services/StorageService";
import EnergiaStats from "@/components/energia/EnergiaStats";
import GeradoresAtivos from "@/components/energia/GeradoresAtivos";
import ClientesAtivos from "@/components/energia/ClientesAtivos";
import { 
  calculateEnergiaResumo, 
  getTopGeradores, 
  getTopClientes,
  EnergiaResumo 
} from "@/components/energia/EnergiaCalculations";
import { Cliente, Gerador } from "@/types";

const EnergiaDashboard = () => {
  const [resumo, setResumo] = useState<EnergiaResumo>({
    totalClientes: 0,
    totalConsumo: 0,
    percentualUsoGerador: 0,
    totalEconomia: 0,
    receitaTotal: 0,
    ultimaAtualizacao: new Date('2025-04-09T16:50:00')
  });
  const [topGeradores, setTopGeradores] = useState<Gerador[]>([]);
  const [topClientes, setTopClientes] = useState<Cliente[]>([]);

  useEffect(() => {
    const clientes = ClienteService.getAll().filter(c => c.tipo === 'energia');
    const geradores = GeradorService.getAll();
    
    setResumo(calculateEnergiaResumo(clientes, geradores, new Date('2025-04-09T16:50:00')));
    setTopGeradores(getTopGeradores(geradores));
    setTopClientes(getTopClientes(clientes));
  }, []);

  return (
    <Layout>
      <div className="container mx-auto px-4 py-6 max-w-6xl">
        <EnergiaStats resumo={resumo} />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <GeradoresAtivos topGeradores={topGeradores} />
          <ClientesAtivos topClientes={topClientes} />
        </div>
      </div>
    </Layout>
  );
};

export default EnergiaDashboard;
